import { addressInfoFrag } from '../../../../../../utils/type/address.common-type';
import { personInfoFrag } from '../../../../../../utils/type/person.common-type';
import { userInfoFrag } from '../../../../../../utils/type/user.common-type';

export const plannedWorkFragment = `
    id
    eventType
    eventData
    dateFrom
    hidden
    occurrenceFolders {
        id
        serviceId
        person {
            ${personInfoFrag}
        }
        serviceAddress {
            address {
                ${addressInfoFrag}
            }
        }
    }
    occurrenceUsers {
        ${userInfoFrag}
    }
    offers {
        offerId
        offer {
            id
            name
            code
        }
    }
`;
